import { Injectable } from '@angular/core';
import { getAcceptLanguage } from '../helpers/getAcceptLanguage';
import { BaseApiService } from './base-api.service';
import { AccountService } from './account.service';
import { Observable, catchError, map, throwError } from 'rxjs';
import { PagedResponse } from '../models/paged-response.model';
import { FiweDmsDto } from '../models/fiweDmsDto';
import { HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DmsService {
  lang = getAcceptLanguage.getLocalStorageLanguage();

  constructor(private api: BaseApiService,
    private accountService: AccountService) { }

  getPaged(params: any): Observable<PagedResponse<FiweDmsDto>> {
    return this.api.post('dms', params).pipe(
      map((response) => {
        const pagedModel = new PagedResponse<FiweDmsDto>(
          response.body.result
        );
        pagedModel.items = pagedModel.items?.map((i) => new FiweDmsDto(i));
        return pagedModel;
      })
    );
  }

  getUnregisteredAllFirms(): Observable<any> {
    return this.api
      .get('dms/unregistered-all-firms')
      .pipe(catchError(this.handleError<[]>(`dms/unregistered-all-firms`)));
  }

  getUnregisteredFin(params: any): Observable<any> {
    return this.api
      .post('dms/unregistered-fin', params)
      .pipe(catchError(this.handleError<[]>(`dms/unregistered-fin`)));
  }

  getUnregisteredKuf(params: any): Observable<any> {
    return this.api
      .post('dms/unregistered-kuf', params)
      .pipe(catchError(this.handleError<[]>(`dms/unregistered-kuf`)));
  }

  getUnregisteredRim(params: any): Observable<any> {
    return this.api
      .post('dms/unregistered-rim', params)
      .pipe(catchError(this.handleError<[]>(`dms/unregistered-rim`)));
  }

  getById(params: any): Observable<any> {
    return this.api
      .post('dms/by-id', params)
      .pipe(catchError(this.handleError<[]>(`dms/by-id`)));
  }

  create(params: any, files): Observable<any> {
    return this.api
      .postFormDataMultipleFiles('dms/create', params, files)
      .pipe(catchError(this.handleError<[]>(`dms/obilasci/create`)));
  }

  update(params: any, files): Observable<any> {
    return this.api
      .postFormDataMultipleFiles('dms/update', params, files)
      .pipe(catchError(this.handleError<[]>(`dms/update`)));
  }

  getCreated(params: any): Observable<any> {
    return this.api
      .post('dms/get-created', params)
      .pipe(catchError(this.handleError<[]>(`dms/get-created`)));
  }

  getFile(fileName) {
    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept-Language': this.lang,
      firmaid: this.accountService.context?.organizationId?.toString() || '',
      godina: this.accountService.context?.year?.toString() || '',
      Authorization: 'Bearer ' + this.accountService.accessToken.token,
    });
    return this.api.newRequest(
      'post',
      `${environment.apiUrl}dms/get-file`,
      {
        fileName: fileName,
      },
      {},
      {
        headers,
        responseType: 'blob',
        observe: 'response'
      }
    );
  }

  updateFin(params: any): Observable<any> {
    return this.api
      .post('dms/update-fin', params)
      .pipe(catchError(this.handleError<[]>(`dms/update-fin`)));
  }

  updateKuf(params: any): Observable<any> {
    return this.api
      .post('dms/update-kuf', params)
      .pipe(catchError(this.handleError<[]>(`dms/update-kuf`)));
  }

  updateRim(params: any): Observable<any> {
    return this.api
      .post('dms/update-rim', params)
      .pipe(catchError(this.handleError<[]>(`dms/update-rim`)));
  }

  proknjiziRucno(params: any): Observable<any> {
    return this.api
      .post('dms/proknjizi-rucno', params)
      .pipe(catchError(this.handleError<[]>(`dms/proknjizi-rucno`)));
  }

  delete(params: any): Observable<any> {
    return this.api
      .post('dms/delete', params)
      .pipe(catchError(this.handleError<[]>(`dms/delete`)));
  }

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      const errorMsg = `${operation} failed: ${error.message}`;

      return throwError(error);
    };
  }
}
